import { HIDE_SIDEBAR, SHOW_SIDEBAR, TOGGLE_SIDEBAR } from '../actions/sidebar.actions';

const initialState = {
    active: null
};

const sidebarReducer = function (state = initialState, action) {
    switch (action.type) {
        case SHOW_SIDEBAR:
            return {
                ...state,
                active: action.payload
            };
        case HIDE_SIDEBAR:
            return {
                ...state,
                active: null
            };
        case TOGGLE_SIDEBAR:
            return {
                ...state,
                active: state.active !== action.payload ? action.payload : null
            };
        default:
            return state;
    }
}

export default sidebarReducer;